module.exports = __webpack_public_path__ + "img/Clear Icon - white.37de578c.svg";